export { default } from '@shikijs/langs/markdown'
